import { Box, Typography } from "@mui/material";
import IconConstants from "../../utils/IconConstants";

export default function MaintenancePage({ message, contact }) {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#FEFCF9",
        p: 2,
      }}
    >
      <Box sx={{ textAlign: "center", maxWidth: 520, width: "100%" }}>
        <Box
          component="img"
          src={IconConstants.GuestHivesLogo}
          alt="GuestHives"
          sx={{
            width: { xs: 56, sm: 72 },
            height: { xs: 56, sm: 72 },
            mb: { xs: 2, sm: 3 },
          }}
        />

        <Typography
          sx={{
            fontSize: { xs: "1.4rem", sm: "1.75rem" },
            fontWeight: 700,
            background: "linear-gradient(135deg, #DEA829, #F79072)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
            mb: 1,
          }}
        >
          We'll Be Right Back
        </Typography>

        <Typography
          sx={{
            fontSize: { xs: "0.9rem", sm: "1rem" },
            color: "#4C4C4C",
            lineHeight: 1.6,
            mb: 3,
          }}
        >
          {message ||
            "GuestHives is currently undergoing scheduled maintenance to bring you a better experience."}
        </Typography>

        <Box
          sx={{
            background: "#FFFFFF",
            border: "1px solid rgba(247,168,110,0.25)",
            borderRadius: "12px",
            p: 2.5,
            boxShadow: "0 4px 24px rgba(222,168,41,0.06)",
            mb: 3,
          }}
        >
          <Box
            sx={{
              display: "inline-flex",
              alignItems: "center",
              gap: 0.75,
              px: 1.5,
              py: 0.5,
              background:
                "linear-gradient(90deg, rgba(226,165,50,0.08), rgba(247,144,114,0.08))",
              borderRadius: "20px",
              fontSize: "0.8rem",
              fontWeight: 600,
              color: "#C47A2A",
              mb: 1.5,
            }}
          >
            <Box
              sx={{
                width: 8,
                height: 8,
                backgroundColor: "#E2A532",
                borderRadius: "50%",
                animation: "pulse 2s ease-in-out infinite",
                "@keyframes pulse": {
                  "0%, 100%": { opacity: 1, transform: "scale(1)" },
                  "50%": { opacity: 0.5, transform: "scale(0.85)" },
                },
              }}
            />
            Maintenance in Progress
          </Box>

          <Typography sx={{ fontSize: "0.875rem", color: "#4C4C4C", lineHeight: 1.6 }}>
            Our team is working on improvements. This won't take long — please
            check back shortly.
          </Typography>
        </Box>

        <Box
          sx={{
            width: 48,
            height: 3,
            background: "linear-gradient(90deg, #E2A532, #F79072)",
            borderRadius: 2,
            mx: "auto",
            mb: 2,
          }}
        />

        {contact && (
          <Typography sx={{ fontSize: "0.78rem", color: "#9E9E9E" }}>
            Need urgent help? Contact us at{" "}
            <Box
              component="a"
              href={`mailto:${contact}`}
              sx={{ color: "#E2A532", textDecoration: "none", fontWeight: 500 }}
            >
              {contact}
            </Box>
          </Typography>
        )}
      </Box>
    </Box>
  );
}
